import { dashboardTotalDataTypes } from "../../types";
const initialState = {
    data: {},
    loading: false,
    error: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case dashboardTotalDataTypes.FETCH:
            return { ...state, loading: true }
        case dashboardTotalDataTypes.SUCCESS:
            return { ...state, data: payload, loading: false, error: "", }
        case dashboardTotalDataTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case dashboardTotalDataTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;